module.exports = __webpack_public_path__ + "img/cnd_Multiplatform.5352c163.svg";